import React, { useEffect, useState } from 'react';
import styles from './Alert.module.scss';

type AlertProps = {
    text: string;
    onHide?: () => void;
}

const Alert = ({ text, onHide }: AlertProps) => {
  const [show, setShow] = useState<boolean>(false);

  useEffect(() => {
    if (text) {
      setShow(true);
      setTimeout(() => {
        setShow(false);
        onHide?.();
      }, 5000);
    }
  }, [text]);

  return show ? (
    <div className={styles.wrapper}>
      <div className={styles.iconWrapper}>
        <p>Ошибка</p>
      </div>
      <div className={styles.textWrapper}>
        <p>{text}</p>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default Alert;
